<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WPLAMe/tc-custom/FC-9789948366485.jpg?1619524873398" alt="This image is the cover for the book الخاتم العجيب"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">الخاتم العجيب
      </h1>
      <p class="bookDescription body article font2">
        <p>القصة مغامرة مشوقة تعتمد على حكاية شعبية عن خاتم سحري عجيب يسمى خاتم الاسم الأعظم، من يجد هذا الخاتم يستطيع الحصول على ما يريد. فيقرر الأصدقاء الثلاثة خوض المغامرة بعد أن وجدوا هذا الخاتم في صندوق قديم، ويطلبون من الخاتم العجيب أن يأخذهم في رحلة عبر البلاد العربية للتعرف عليها، فماذا يجدون؟</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        أحلام يحيى جحاف
      </h2>
      
      <p class="authorDescription body article">أحلام يحيى جحاف كاتبة يمنية.. حاصلة على درجة الماجستير في الإدارة. عملت في مجال التعليم معلّمِة لمادة الرياضيات، ثم انتقلت للعمل مدربة ومعدة أدلَّة وحقائب تدريبية بقطاع التدريب في وزارة التربية والتعليم. نُشر لهاعدد من القصص القصيرة مع آخرين في كتابين: "خطوات - مبدعون من أجل حقوق الأطفال" و"خطوات 2" عبر مؤسسة إبحار للطفولة والإبداع، كما شاركت في عدد من مسابقات القصة القصيرة، ونُشرت لها قصص فائزة في عدد من الكتب الجماعية: "المنفيون إلى جوار السحاب" المكتبة العربية للنشر والتوزيع، "صندوق الدنيا" لدار زين للنشر والتوزيع، "شموس" لدار مها للنشر والتوزيع، و"سبيل الأمم" مع مبادرة حلم الوصول.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4841ed5a